<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <div
      class="select-group">
      <v-select
        :disabled="disabled"
        :value="value"
        v-on="listeners"
        :searchable="searchable"
        :options="options"
        form-size="xs"
        :error="error">
      </v-select>
      <slot />
    </div>
    <div
      :class="error ? 'error-message' : 'hidden'">
      <font-awesome-icon
        :icon="infoCircle"/>
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle';
import vSelect from 'vue-select';

export default {
  components: {
    FontAwesomeIcon,
    vSelect
  },
  props: {
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    options: {
      type: Array
    },
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listeners () {
      return {
        input: event => this.$emit('input', event)
      };
    },
    infoCircle () {
      return faInfoCircle;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

$form-minw: $sp * 50;

.form-group {
  display: block;
  margin-bottom: $sp-margin-large;
  label {
    display: block;
    color: $black-trans4;

    .form--inverse & {
      color: $white-trans4;
    }
  }
  .v-select.v-select {
    background-color: $white;
    border: 1px solid $black-trans6;
    border-radius: $radius;
    padding-left: $sp-margin-small;
    padding-right: $sp-margin-small;
    //TODO: HOW TO OVERRIDE THIS SETTING?
    //min-width: $form-minw;
    width: 100%;
    font-size: 1em;
    &:hover {
      border-color: $black-trans4;
    }
    &:focus,
    &:active {
      outline: 0;
      border-color: $active;
    }

    .form--inverse & {
      background-color: transparent;
      border-color: $white-trans6;
      color: $white;
      &::placeholder {
        color: $white-trans6;
      }
      &:hover {
        border-color: $white-trans4;
      }
      &:focus,
      &:active {
        border-color: $active;
      }
    }
    &[error="true"] {
      border-color: $error;
    }
  }
  .error-message {
    color: $error;
  }

  .v-select.disabled {
    background-color: $disabled;
  }

  .hidden {
    visibility: hidden;
  }
}

@mixin form-size($font-size, $height) {
  .form-group,
  &.form-group {
    font-size: $font-size;
  }
  .v-select {
    height: $height;
  }
}
[form-size="xs"] {
  @include form-size($fs-xs, $height1);
}
[form-size="s"] {
  @include form-size($fs-s, $height2);
}
[form-size="m"] {
  @include form-size($fs, $height3);
}
[form-size="l"] {
  @include form-size($fs-xl, $height5);
}

.select-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/forms/LabelSelect.vue